import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { buildStackedBarItemTooltipOptions } from "./stackedBarItemTooltip";

// The numeric field's dataType lives on chartTypeParam.x here (roles swapped in the translator).
export function translateStackedBarHorizontalResponseTooltipOptions(
  states: EvaChartStates
): TooltipOption {
  return buildStackedBarItemTooltipOptions(
    states,
    states.chartTypeParam?.properties?.x?.dataType
  );
}
